import { LoaderSpinner } from '@lightspeed/design-system-react'
import React, { FunctionComponent } from 'react'

export const QKLocked: FunctionComponent = () => {
  return (
    <div className="vd-quick-key vd-quick-key--blank vd-quick-key--locked">
      <div className="vd-quick-key--loader">
        <LoaderSpinner />
      </div>
    </div>
  )
}
